// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthorized-alert-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 3em;
}

.unauthorized-alert {
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/components/unauthorizedAlert/unauthorizedAlert.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AACD;;AAEA;EACC,kBAAA;AACD","sourcesContent":[".unauthorized-alert-container{\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding-top: 3em;\n}\n\n.unauthorized-alert{\n\twidth: fit-content;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
